/**
 * El carrito abre angosto (30% en escritorio / 62% en mobile, ver
 * snippets/cart-drawer.liquid). En cuanto el cliente hace clic en cualquier
 * parte de adentro del carrito ya abierto, se expande a pantalla completa
 * (una sola vez por apertura) para que pueda ver y operar todo con
 * comodidad. Al cerrar el carrito, vuelve a abrir angosto la próxima vez.
 */
(function () {
  var EXPANDED_CLASS = 'is-expanded';

  function getCartDrawerRoot() {
    return document.getElementById('cart-drawer');
  }

  document.addEventListener('click', function (event) {
    var dialog = event.target.closest('#cart-drawer .theme-drawer__dialog[open]');
    if (!dialog) return;
    if (dialog.dataset.auroraExpanded === 'true') return;

    var root = getCartDrawerRoot();
    if (root) root.classList.add(EXPANDED_CLASS);

    // Forzado directo por JS: por alguna razón la cascada de CSS no está
    // dejando ganar la regla #cart-drawer.is-expanded .theme-drawer__dialog
    // (algo en el sistema de animación de apertura del tema la pisa), así
    // que se fuerza el estilo inline con !important, que siempre gana.
    dialog.style.setProperty('width', '100vw', 'important');
    dialog.style.setProperty('right', '0', 'important');
    dialog.style.setProperty('animation', 'none', 'important');
    dialog.dataset.auroraExpanded = 'true';
  });

  // Al cerrar el <dialog> (backdrop, X, Escape, o JS), se resetea para que
  // la próxima apertura vuelva a empezar angosta.
  document.addEventListener(
    'close',
    function (event) {
      var dialog = event.target;
      if (!(dialog instanceof HTMLElement)) return;
      if (!dialog.matches('.theme-drawer__dialog')) return;
      if (!dialog.closest('#cart-drawer')) return;

      var root = getCartDrawerRoot();
      if (root) root.classList.remove(EXPANDED_CLASS);
      dialog.style.removeProperty('width');
      dialog.style.removeProperty('right');
      dialog.style.removeProperty('animation');
      delete dialog.dataset.auroraExpanded;
    },
    true
  );
})();
